import React from "react";

const FairPracticeCode = () => (
  <div
    style={{ minHeight: "100vh", background: "#050A18", padding: "0 0 48px 0" }}
  >
    <div
      style={{
        background: "#111827",
        color: "#fff",
        padding: "56px 0 36px 0",
        textAlign: "center",
      }}
    >
      <div className="text-3xl font-bold tracking-wide text-center mb-2">
        <h2>
          <span className="text-[#4FA0FF]">Fair</span>
          <span className="text-[white] ml-1">Practice Code</span>
        </h2>
      </div>

      <p style={{ fontSize: "1.1rem", marginTop: 12, color: "#e0e0e0" }}>
        Reviewed by Board of Directors | Approved on 15 April 2025
      </p>
    </div>

    <div
      style={{
        maxWidth: 900,
        margin: "40px auto",
        background: "#111827",
        borderRadius: 16,
        boxShadow: "0 4px 24px 0 rgba(79, 160, 255, 0.1)",
        padding: "40px 28px",
        color: "#1D3557",
        fontSize: "1.08rem",
        lineHeight: 1.7,
        border: "1px solid gray",
      }}
    >
      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          Fair Practice Code
        </h2>
        <p className="text-gray-300">
          Kubermax is committed to following a customer-first and transparent approach in all its interactions.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          We Ensure That
        </h2>
        <ul style={{ paddingLeft: 20, listStyleType: "disc" }}>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>All terms, conditions, and applicable charges</strong> are clearly communicated before onboarding
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            Customers are provided with <strong>complete clarity regarding their obligations</strong> and repayment expectations
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>No misleading information or false commitments</strong> are made at any stage
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            Customer data is handled with <strong>strict confidentiality and security measures</strong>
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            All communication and support are conducted in a <strong>professional, respectful, and non-coercive manner</strong>
          </li>
        </ul>
      </section>

      <section>
        <p className="text-gray-300">
          Our aim is to build long-term relationships based on trust, clarity, and ethical practices, ensuring a smooth and reliable experience for every customer.
        </p>
        <div style={{ marginTop: "32px", paddingTop: "16px", borderTop: "1px solid rgba(75, 85, 99, 0.5)" }}>
          <p style={{ fontSize: "0.875rem", color: "#9ca3af", marginBottom: "4px" }}>
            <strong style={{ color: "#4FA0FF" }}>Place:</strong> Uttar Pradesh
          </p>
          <p style={{ fontSize: "0.875rem", color: "#9ca3af" }}>
            <strong style={{ color: "#4FA0FF" }}>Date:</strong> 15 April 2025
          </p>
        </div>
      </section>
    </div>
  </div>
);

export default FairPracticeCode;